<!-- @Author: Yu_Bo 2023-09-07 10:54:40-->
<template>
    <div class="model_vue">
        <!-- 标题 -->
        <div class="vue_title">
            <div class="nav_txt" :class="navIndex == 1 ? 'nav_active' : ''" @click="navBtn(1)">模特管理</div>
            <div class="nav_txt" :class="navIndex == 2 ? 'nav_active' : ''" @click="navBtn(2)">模特分类</div>
        </div>
        <!--  -->
        <div class="model_main">
            <div class="main_condition">
                <div class="cond_left">
                    <el-button type="primary" class="btnBgColor_blue_empty" @click="addModelClassify" size="small" icon="el-icon-plus">{{ navIndex == 1 ? '添加模特' : '添加分类' }}</el-button>
                    <el-input v-model="name" size="small" @keyup.enter.native="searchBtn" @clear='searchBtn' v-if="navIndex==1" :clearable="true" placeholder="搜索模特名称"></el-input>
                    <el-select v-model="gender" size="small" @change="searchBtn" :clearable="true" placeholder="选择性别" v-if="navIndex==1">
                        <el-option v-for="item in genderList" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <el-select v-model="background_type" size="small" @change="searchBtn" :clearable="true" placeholder="选择背景类型" v-if="navIndex==1">
                        <el-option v-for="item in background_type_list" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <el-select v-model="is_vip" size="small" @change="searchBtn" :clearable="true" placeholder="是否会员" v-if="navIndex==1">
                        <el-option v-for="item in vipList" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <el-select v-model="category" size="small" @change="searchBtn" :clearable="true" placeholder="选择归属类型" v-if="navIndex==1">
                        <el-option v-for="item in categoryList" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                    <el-input v-model="name" size="small" @keyup.enter.native="searchBtn" @clear='searchBtn' v-if="navIndex==2" :clearable="true" placeholder="搜索分类名称"></el-input>
                </div>
            </div>
            <!-- 图片列表 -->
            <div class="main_table" v-show="navIndex == 1">
                <model-list ref="model"></model-list>
            </div>
            <div class="main_table" v-show="navIndex == 2">
                <classify-list ref="classify" :parent_id="1"></classify-list>
            </div>
        </div>

    </div>
</template>

<script>
import ModelList from '../components/model/model_list'//模特列表
import ClassifyList from '../components/classify/index.vue'//分类列表
export default {
    components: { ModelList, ClassifyList },
    props: {},
    data() {
        return {
            navIndex: 1,
            // 名称
            name: '',
            // 性别
            gender: '',
            genderList: [],
            // 背景类型
            background_type: '',
            background_type_list: [],
            // 是否会员
            is_vip: '',
            vipList: [],
            // 类型
            category: '',
            categoryList: [],
        };
    },

    computed: {},

    watch: {},

    created() { },

    mounted() {
        this.getCat()
    },

    methods: {
        // 参数
        getCat() {
            var that = this
            that.$marketApi.marketModelParams().then(res => {
                if (res.code == 1000) {
                    that.genderList = res.result.gender
                    that.background_type_list = res.result.background_type
                    that.vipList = res.result.is_vip
                    that.categoryList = res.result.category
                } else {
                    that.$errMsg(res.message)
                }
            })
        },
        // 切换
        navBtn(val) {
            this.navIndex = val
            this.name = ''
            this.gender = ''
            this.background_type = ''
            this.is_vip = ''
            this.category = ''
            this.searchBtn()
            this.getCat()
        },
        // 添加
        addModelClassify() {
            if (this.navIndex == 1) {
                // 模特
                this.$router.push('/market/model/add_edit')
            } else if (this.navIndex == 2) {
                // 分类
                this.$refs.classify.addClassify()
            }
        },
        // 搜索
        searchBtn() {
            if (this.navIndex == 1) {
                // 模特
                var obj = {
                    name: this.name,
                    gender: this.gender,
                    background_type: this.background_type,
                    is_vip: this.is_vip,
                    category: this.category,
                }
                this.$refs.model.search(obj)
            } else if (this.navIndex == 2) {
                // 分类
                var obj = {
                    name: this.name,
                }
                this.$refs.classify.search(obj)
            }
        },
    }
}
</script>
<style lang='scss' scoped>
.model_vue {
    width: 100%;

    .nav_txt {
        cursor: pointer;
        margin-right: 40px;
    }

    .nav_active {
        color: #2e4bf2;
    }

    .model_main {
        width: 100%;
        padding: 0 20px;

        .main_condition {
            width: 100%;
            padding: 20px 0;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .cond_left {
                display: flex;
                align-items: center;

                .el-button {
                    padding: 8px 10px;
                    margin-right: 20px;
                }

                .el-select {
                    margin-right: 20px;
                    width: 160px;
                }

                .el-input {
                    margin-right: 20px;
                    width: 160px;
                }
            }
        }
    }
}
</style>